<template>
  <div class="b-page">
    <Page
      v-bind="$attrs"
      v-on="$listeners"
      @on-change="changeHandle"
      @on-page-size-change="changePageSizeHandle"
      show-total show-elevator show-sizer></Page>
  </div>
</template>

<script>
  export default {
    name: 'BPage',
    props: {
      /**
       * 当前使用的是mixin中的哪一个page
       */
      pageChange: {
        type: Function,
        require: true
      },
      pageSizeChange: {
        type: Function
      }
    },
    created () {
    },
    methods: {
      changeHandle (pageNum) {
        let page = this.$attrs.page
        page.pageNum = pageNum
        this.$nextTick(() => {
          this.pageChange()
        })
      },
      changePageSizeHandle (pageSize) {
        // 如果页码被修改，重新查询则pageNum重置为1
        let page = this.$attrs.page
        page.pageSize = pageSize
        page.pageNum = 1
        this.$nextTick(() => {
          this.pageChange() // 无论翻页还是切换页面条数，在同一个页面默认都是同一个接口，所以这里复用pageChange
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .b-page {
    width: 100%;
    margin-top: 5px;
    text-align: right;
  }
</style>
